import { c as _c } from "react/compiler-runtime";
import { Card } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import { Separator } from '@achra/ui/separator';
import { percentageRespectTo } from '@/modules/finances/lib';
import type { QuarterCardProps } from '@/modules/finances/types';
import { threeDigitsPrecisionHumanization } from '@/shared/lib/humanization';
import { getPercentDisplay } from '../doughnut-chart';
import { MetricDisplay } from './horizontal-budgetbar';
import { HorizontalBudgetBar } from './horizontal-budgetbar/horizontal-budget-bar';
import { LegendItem } from './horizontal-budgetbar/legend-item';
function BudgetUtilizationCard(t0) {
  const $ = _c(33);
  const {
    paymentsOnChain,
    budgetCap
  } = t0;
  let t1;
  if ($[0] !== paymentsOnChain) {
    t1 = threeDigitsPrecisionHumanization(paymentsOnChain);
    $[0] = paymentsOnChain;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const humanizedActuals = t1;
  let t2;
  if ($[2] !== budgetCap) {
    t2 = threeDigitsPrecisionHumanization(budgetCap);
    $[2] = budgetCap;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const humanizedBudgetCap = t2;
  let isRightPartZero;
  let t3;
  if ($[4] !== budgetCap || $[5] !== paymentsOnChain) {
    const percent = percentageRespectTo(paymentsOnChain, budgetCap);
    isRightPartZero = budgetCap === 0;
    t3 = budgetCap === 0 ? "-- " : getPercentDisplay(percent);
    $[4] = budgetCap;
    $[5] = paymentsOnChain;
    $[6] = isRightPartZero;
    $[7] = t3;
  } else {
    isRightPartZero = $[6];
    t3 = $[7];
  }
  const percentDisplay = t3;
  let t4;
  if ($[8] !== humanizedActuals.suffix || $[9] !== humanizedActuals.value) {
    t4 = <MetricDisplay amount={humanizedActuals.value} currency="USD" unit={humanizedActuals.suffix} />;
    $[8] = humanizedActuals.suffix;
    $[9] = humanizedActuals.value;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator data-slot="divider-actuals-budget-cap" orientation="vertical" className={cn("bg-foreground origin-center rotate-12 self-center text-2xl font-semibold data-[orientation=vertical]:h-8! data-[orientation=vertical]:w-1!")} />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== humanizedBudgetCap.suffix || $[13] !== humanizedBudgetCap.value) {
    t6 = <MetricDisplay amount={humanizedBudgetCap.value} currency="USD" unit={humanizedBudgetCap.suffix} />;
    $[12] = humanizedBudgetCap.suffix;
    $[13] = humanizedBudgetCap.value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="flex flex-row justify-center gap-2.5">{t4}{t5}{t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div data-slot="description" className="text-foreground/50 mt-0.25 text-center text-xs/4.5 font-medium">MakerDAO Total Budget</div>;
    t9 = <Separator className="my-2.5" orientation="horizontal" />;
    $[18] = t8;
    $[19] = t9;
  } else {
    t8 = $[18];
    t9 = $[19];
  }
  const t10 = isRightPartZero ? "text-muted-foreground" : "text-foreground";
  let t11;
  if ($[20] !== t10) {
    t11 = cn("text-center text-xl leading-[120%] font-bold", t10);
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== percentDisplay || $[23] !== t11) {
    t12 = <div data-slot="percent" className={t11}>{percentDisplay}%</div>;
    $[22] = percentDisplay;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== budgetCap || $[26] !== paymentsOnChain) {
    t13 = <div data-slot="bar-wrapper" className="mt-1 mb-1 flex items-center gap-2"><HorizontalBudgetBar actuals={paymentsOnChain} prediction={0} budgetCap={budgetCap} /></div>;
    $[25] = budgetCap;
    $[26] = paymentsOnChain;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div data-slot="legend" className="flex justify-between pl-px md:mt-px 2xl:mt-0"><LegendItem color="bg-status-success" className="hidden xl:block">Net Expenses On-chain</LegendItem><LegendItem color="bg-status-success" className="block xl:hidden">Net Exp On-chain</LegendItem><LegendItem color="bg-destructive">Budget Cap</LegendItem></div>;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t7) {
    t15 = <Card data-slot="budget-utilization-card" className="bg-popover flex w-full flex-col gap-0 border-none px-8 py-3.25 lg:py-4">{t7}{t8}{t9}{t12}{t13}{t14}</Card>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t7;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}
export { BudgetUtilizationCard };